
import { initializeApp } from "firebase/app";
import {getAuth} from "firebase/auth"
import { getFirestore, collection, getDocs } from 'firebase/firestore/lite';

const firebaseConfig = {
	apiKey: "AIzaSyCOBftGUUcgQ0sybZCUvdsqbY1AJuyInX8",
	authDomain: "saurashtra-3e504.firebaseapp.com",
	databaseURL: "https://saurashtra-3e504-default-rtdb.firebaseio.com",
	projectId: "saurashtra-3e504",
	storageBucket: "saurashtra-3e504.appspot.com",
	messagingSenderId: "868873940931",
	appId: "1:868873940931:web:91e27abece8ba668489776",
	measurementId: "G-PWSEYS6CPY"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app)
export const auth = getAuth(app)

